module.exports = __webpack_public_path__ + "static/media/heart20.8aca0523.svg";